import SupervisorApi from './supervisorApi';
import { store } from '../store';
import { isAutotask, isNinjaOne } from '../utils/mspUtils';

// Navigation intent only. One provider-backed prefetch at a time, never a sweep
// of every visible ticket. Results live in the authenticated shared server cache.
let timer: ReturnType<typeof setTimeout> | null = null;
let active = false;
const attempted = new Map<string, number>();
const api = new SupervisorApi();
function prefetchRead(readKey: string, load: () => Promise<any>) {
  if (timer) clearTimeout(timer);
  const auth = store?.getState()?.auth;
  const identity = JSON.stringify([auth?.accessToken, auth?.user?.email]);
  const key = JSON.stringify([identity, readKey]);
  timer = setTimeout(() => {
    timer = null;
    const current = store?.getState()?.auth;
    if (identity !== JSON.stringify([current?.accessToken, current?.user?.email]) || active) return;
    if (Date.now() - (attempted.get(key) || 0) < 30_000) return;
    if (attempted.size >= 100) attempted.delete(attempted.keys().next().value!);
    attempted.set(key, Date.now());
    active = true;
    void load().catch(() => {
      attempted.delete(key);
    }).finally(() => { active = false; });
  }, 200);
}
export function cancelTicketPrefetch() {
  if (timer) clearTimeout(timer);
  timer = null;
}

export function prefetchSupervisorList(mspType: string | undefined, filters: {
  groupName?: string; categoryName?: string[]; boardId?: number;
  status?: string[]; customer?: string[]; includeAllStatuses?: boolean;
} = {}) {
  if (!mspType || (isNinjaOne(mspType) && !filters.boardId)) return;
  prefetchRead(JSON.stringify(["list", mspType, filters]), () => {
    const sort = [{ attribute: "created_at", order: "DESC" as const }];
    if (isNinjaOne(mspType)) return api.getNinjaoneTickets(1, 500, filters, sort);
    if (isAutotask(mspType)) return api.getAutotaskTickets(1, 500, filters, sort);
    return api.getSuperopsTickets(1, 500, filters, sort);
  });
}
